export default {
    name: 'generalInventory',
    component: () => import(/* webpackChunkName: "general-inventory-Layout" */ '@/modules/generalInventory/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.generalInventory.index',
            component: () => import(/* webpackChunkName: "general-inventory-index" */ '@/modules/generalInventory/views/Index'),
        },
    ]
}